import { render, staticRenderFns } from "./TitleWidget.vue?vue&type=template&id=5ae84d66"
import script from "./TitleWidget.vue?vue&type=script&lang=js"
export * from "./TitleWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports